export default "__VITE_ASSET__n4xa5h_I__"